import React from 'react';
import img from './cameraSwitch_lg.svg'

const SwitchCameraButton = (props) => {

    return(
        <img style={{width: '2em'}} onClick={props.onClick} src={img} />
    );
}
export default SwitchCameraButton;